/**
 * Coarse lifecycle state of a ProcessAttempt, as reported by the backend's
 * `ProcessAttemptStatus` enum. Keep the numeric values in sync with
 * `MadCloud.Domain.Process.ProcessAttemptStatus` — they cross the wire as integers.
 */
export enum ProcessAttemptStatus {
  Queued = 0,
  Running = 1,
  Complete = 2,
  Failed = 3,
  Aborted = 4,
  Canceled = 5
}
